export const VIEWPORT_WIDTH = 1600;
export const VIEWPORT_HEIGHT = 900;
export const ARENA_WIDTH = VIEWPORT_WIDTH * 2;
export const ARENA_HEIGHT = VIEWPORT_HEIGHT * 2;
export const MAX_PLAYERS = 75;
export const TICK_MS = 40;
export const SNAPSHOT_MS = 80;
export const REVIVE_DURATION_MS = 3_000;
export const REVIVE_SHIELD_DURATION_MS = 2_500;
export const LOOT_CHOICE_DURATION_MS = 12_000;
export const PERSONAL_CHALLENGE_COMPLETE_DISPLAY_MS = 2_500;
export const PERSONAL_CHALLENGE_REFRESH_MS = 7_000;
export const PLAYER_IDLE_TIMEOUT_MS = 30_000;
export const ULTIMATE_BARRAGE_CHARGES = 6;
export const REVIVE_RADIUS = 46;
export const XP_GAIN_MULTIPLIER = 1.5625;
export const MATCH_DURATION_MS = 10 * 60 * 1000;
export const BOSS_START_MS = 8 * 60 * 1000;
export const MINIBOSS_INTERVAL_MS = 45_000;
export const NAMED_ENEMY_REPEAT_MS = 35_000;
export const RESULTS_DURATION_MS = 30 * 1000;
export const MOTE_CAPACITY = 8;
export const OBJECTIVE_STATION_RADIUS = 84;
export const AMBER_CACHE_X = ARENA_WIDTH / 2 - 82;
export const AMBER_CACHE_Y = ARENA_HEIGHT / 2;
export const BAIT_PEN_X = ARENA_WIDTH / 2 + 82;
export const BAIT_PEN_Y = ARENA_HEIGHT / 2;
export const PARK_LANDMARKS = {
  tourRoute: { x: ARENA_WIDTH * 0.18, y: ARENA_HEIGHT * 0.56 },
  rangerCamp: { x: ARENA_WIDTH * 0.3, y: ARENA_HEIGHT * 0.24 },
  paddockGate: { x: ARENA_WIDTH * 0.78, y: ARENA_HEIGHT * 0.28 },
  visitorDrop: { x: ARENA_WIDTH * 0.57, y: ARENA_HEIGHT * 0.69 },
  hatchery: { x: ARENA_WIDTH * 0.72, y: ARENA_HEIGHT * 0.73 },
  researchWest: { x: ARENA_WIDTH * 0.24, y: ARENA_HEIGHT * 0.78 },
  researchEast: { x: ARENA_WIDTH * 0.82, y: ARENA_HEIGHT * 0.46 },
} as const;
export const FOOD_SUPPLY_SOURCES = [
  PARK_LANDMARKS.tourRoute,
  PARK_LANDMARKS.rangerCamp,
  PARK_LANDMARKS.visitorDrop,
  PARK_LANDMARKS.hatchery,
] as const;
export const OVERDRIVE_DURATION_MS = 18_000;
export const FRENZY_SPEED_MULTIPLIER = 1.65;
export const FRENZY_XP_MULTIPLIER = 2;

export const SURVIVOR_SKINS = [
  "jham",
  "neddy",
  "orem",
  "docsalad",
  "chaosmal",
  "wuops",
  "clairebear",
  "lockbox",
  "kwatt",
  "slysoya",
] as const;
export type SurvivorSkin = (typeof SURVIVOR_SKINS)[number];

export function normalizeSurvivorSkin(
  value: string | null | undefined,
): SurvivorSkin {
  return SURVIVOR_SKINS.includes(value as SurvivorSkin)
    ? (value as SurvivorSkin)
    : "jham";
}

export const ABILITIES = [
  "ember",
  "moon",
  "chain",
  "void",
  "frost",
  "solar",
  "raven",
  "necro",
  "bard",
] as const;
export type AbilityId = (typeof ABILITIES)[number];

export const ABILITY_NAMES: Record<AbilityId, string> = {
  ember: "Cattle Prod",
  moon: "Barbasol Cans",
  chain: "Live Wire",
  void: "Supply Crate",
  frost: "Tranq Mist",
  solar: "Road Flare",
  raven: "Tranq Darts",
  necro: "Hatchery Tech",
  bard: "Tour Guide",
};

export const ABILITY_COLORS: Record<AbilityId, number> = {
  ember: 0xffd23e,
  moon: 0xc7b8ff,
  chain: 0x69e7ff,
  void: 0xd86cff,
  frost: 0x7fd8c8,
  solar: 0xffcf57,
  raven: 0x9a7cff,
  necro: 0x6fcf5e,
  bard: 0xff8fcb,
};

export const ULTIMATE_NAMES: Record<AbilityId, string> = {
  ember: "Overload",
  moon: "Foam Burst",
  chain: "Blackout Surge",
  void: "Air Drop",
  frost: "Mass Sedation",
  solar: "Flare Storm",
  raven: "Full Volley",
  necro: "Life Finds a Way",
  bard: "Grand Tour",
};

export const ULTIMATE_COOLDOWNS: Record<AbilityId, number> = {
  ember: 25_000,
  moon: 24_000,
  chain: 25_000,
  void: 27_000,
  frost: 27_000,
  solar: 30_000,
  raven: 24_000,
  necro: 28_000,
  bard: 30_000,
};
